<template>
<div class="basicInfo">
    <div class="photo_box">
      <div class="photo">
        <img :src="userInfo.avatar"/>
        <!--        <&#45;&#45;图片地址动态绑定&ndash;&gt;-->
      </div>
      <p class="p1" @click.stop="uploadHeadImg"><button>更换头像</button></p>
      <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png" @change="handleFile" class="hiddenInput"/>
      <p class="p2">建议使用100*100的头像</p>
    </div>
    <label>用户名：</label><input type="text" class="input_border" readonly :placeholder="currentUser.name"><br>
    <label>所属角色：</label><input type="text" class="input_border" readonly :placeholder="currentUser.role_name"><br>
    <!-- <label>姓名：</label><input type="text" class="input_border" readonly :placeholder="currentUser.mobile"><br> -->
    <label>电话：</label><input type="text" class="input_border" readonly :placeholder="currentUser.mobile"><br>
    <label>状态：</label>
    <input type="text" class="input_border" v-if="currentUser.status=='1'" readonly placeholder="启用">
    <input type="text" class="input_border" v-if="currentUser.status=='0'" readonly placeholder="禁用"><br>
  </div>
</template>

<script>
export default {
  name: "basicInfo",
  data() {
    return {
      currentUser:"",
      userInfo: {
        avatar: 'https://gss0.bdstatic.com/-4o3dSag_xI4khGkpoWK1HF6hhy/baike/c0%3Dbaike92%2C5%2C5%2C92%2C30/sign=62d46c39067b020818c437b303b099b6/d4628535e5dde7119c3d076aabefce1b9c1661ba.jpg'
      },
    };
  },
  methods: {
    // 打开图片上传
    uploadHeadImg: function () {
      this.$el.querySelector('.hiddenInput').click()
    },

    // 将头像显示
    handleFile: function (e) {
      let $target = e.target || e.srcElement
      let file = $target.files[0]
      var reader = new FileReader()
      reader.onload = (data) => {
        let res = data.target || data.srcElement
        this.userInfo.avatar = res.result
      }
      reader.readAsDataURL(file)
    },


    getUserInfo: function () {
      fetch("/api/v1/user/info", {
        method: 'post',
        body: JSON.stringify({
          user_id: "35fa2070-ed7e-4369-9434-1a8ceaedfb02",
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            this.currentUser=data.data;
          } 
      }).catch((error) => {
          console.log(error);
      });
    },
  },
  mounted() {
    this.getUserInfo();
  },
  created() {},
  destroyed: function() {}
};
</script>

<style scoped>

  .hiddenInput{
    display: none;
  }

  .photo img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    margin-right: 8px
  }

.basicInfo {
  width: 98%;
  height: 98%;
  box-sizing: border-box;
  background: #0b2f54;
  border-radius: 10px;
  margin-left: 1%;
  margin-top:1%;
}
.basicInfo{
  padding-top:100px;
}
.basicInfo label{
  width:200px;
  color: #ffffff;
  text-align: right;
  margin: 0 10px 0 13%;
}
.input_border{
  border-radius: 4px;
  border:1px solid #556e88 !important;
  background:none;
  padding-left: 10px;
  height: 32px;
  margin: 10px 0 10px 0;
  width: 40%;
  color:#ffffff;
}
.photo_box{
  width: 100%;
  height: 180px;
  margin-bottom: 50px;
}
.photo{
  margin-left: 40%;
  width: 120px;
  height: 120px;
  background: #ffffff;
  border-radius: 100%;
}
.photo_box .p1{
  margin-top:20px;
  margin-left: 42%;
  color:#ffffff;
}

button{
  margin:0; padding:0; list-style-type:none;color:white;border:0px;background-color:transparent;
}

.photo_box .p2{
  color:#679ed6;
  margin-left: 38.3%;
  position: absolute;
  top: 370px;
  left: 180px;
}
</style>



// WEBPACK FOOTER //
// src/components/Setting/basic_info.vue